import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { DatePicker, Input } from "common/InputForm";
import { CustomButton } from "components/form";
import { toastMessage } from "utils/toastMessage";
import { regex } from "utils/formValidator";
import { addProductApi } from "services/product";
import { IoCloudUploadOutline } from "react-icons/io5";
import { GoX } from "react-icons/go";
import Select from "react-select";
import JoditEditor from "jodit-react";
import { masterBrandListApi, masterClothingCategoriesListApi, masterColorApi, masterSizeApi } from "services/master";
import useButtonLoader from "common/UseButtonLoader";
import Form from "pages/web-scraped-product/Form";
const AddProduct = () => {
  const editor = useRef(null);
  // Editor Config
  const config = useMemo(
    () => ({
      readonly: false,
      placeholer: "",
      toolbar: true,
      spellcheck: true,
      language: "en",
      toolbarButtonSize: "medium",
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      uploader: {
        insertImageAsBase64URI: true,
      },
      controls: {
        font: {
          command: "fontname",
          list: {
            "'Open Sans',sans-serif": "Open Sans",
            "Helvetica,sans-serif": "Helvetica",
            "Arial,Helvetica,sans-serif": "Arial",
            "Georgia,serif": "Georgia",
            "Impact,Charcoal,sans-serif": "Impact",
            "Tahoma,Geneva,sans-serif": "Tahoma",
            "'Times New Roman',Times,serif": "Times New Roman",
            "Verdana,Geneva,sans-serif": "Verdana",
            "Consolas,monaco,monospace": "Consolas",
          },
        },
      },
    }),
    []
  );
  // const sizeOptions = [
  //   { value: "XS", label: "XS" },
  //   { value: "S", label: "S" },
  //   { value: "M", label: "M" },
  //   { value: "L", label: "L" },
  //   { value: "XL", label: "XL" },
  // ];
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Save and Submit");
  const [errors, setErrors] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({
    height: [],
    paletteName: [],
    bodyShape: [],
    styleIdentity: [],
    flauntParts: [],
    downplayParts: [],
    occasionName: [],
    availableSizes: [],
    category: '',
    brand: '',
    colorName: ''
  })
  const { imageFileRegex } = regex;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    price: "",
    heightInchValue: [],
    bodyShape: [],
    bodyShapeValue: [],
    styleIdentity: [],
    styleIdentityValue: [],
    flauntParts: [],
    flauntPartsValue: [],
    downplayParts: [],
    downplayPartsValue: [],
    brand: "",
    category: "",
    color: {},
    images: [],
  });
  const [colorList, setColorList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [sizeList, setSizeList] = useState([]);
  const [showSize, setShowSize] = useState(false)
  const [sizeType, setSizeType] = useState("")
  const [occasionName, setOccasionName] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [availableSizes, setAvailableSizes] = useState([]);
  const [paletteName, setPaletteName] = useState([]);
  const paletteOptions = [
    { value: "Bright Spring", label: "Bright Spring" },
    { value: "Bright Winter", label: "Bright Winter" },
    { value: "Dark Autumn", label: "Dark Autumn" },
    { value: "Dark Winter", label: "Dark Winter" },
    { value: "Light Spring", label: "Light Spring" },
    { value: "Light Summer", label: "Light Summer" },
    { value: "Soft Autumn", label: "Soft Autumn" },
    { value: "Soft Summer", label: "Soft Summer" },
    { value: "True Autumn", label: "True Autumn" },
    { value: "True Spring", label: "True Spring" },
    { value: "True Summer", label: "True Summer" },
    { value: "True Winter", label: "True Winter" },
  ];
  const handlePaletteChange = (selectedOptions) => {
    setPaletteName(selectedOptions.map((option) => option.value));
    setErrors((prevData) => ({ ...prevData, paletteName: null }));
  };
  const occasionArray = [
    { value: "Casual", label: "Casual" },
    { value: "Formal", label: "Formal" },
    { value: "Party", label: "Party" },
  ];

  const handleOccasionChange = (selectedOptions) => {
    setOccasionName(selectedOptions.map((option) => option.value));
    setErrors((prevData) => ({ ...prevData, occasionName: null }));
  };
  const handleSizeChange = (selectedOptions) => {
    setAvailableSizes(selectedOptions.map((option) => option.value));
    setErrors((prevData) => ({ ...prevData, availableSizes: null }));
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "category") {
      if (value === "Shoes") {
        setSizeType("shoes")
        setShowSize(false)

      } else if (["Tops", "Bottoms", "Outerwear", "Jumpsuits", "Dresses"].includes(value)) {
        setSizeType("clothes")
        setShowSize(false)

      } else if (["Accessories", "Jewelry"].includes(value)) {
        setShowSize(true)
      }
      sizeListHandler()
    }
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevData) => ({ ...prevData, [name]: null }));
  };
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) => imageFileRegex.test(file.name));
    if (validFiles.length > 0) {
      const imageUrls = validFiles.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      }));
      setFormData((prevData) => ({
        ...prevData,
        images: [...prevData.images, ...imageUrls],
      }));
      setErrors((prevData) => ({ ...prevData, images: null }));
    }
  };
  const handleImageRemove = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      images: prevData.images.filter((_, i) => i !== index),
    }));
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.price) newErrors.price = "Price is required";
    if (!formData.stockQuantity)
      newErrors.stockQuantity = "Stack quantity is required";


    if (selectedOptions?.height?.length === 0)
      newErrors.height = "Height is required";
    if (selectedOptions?.paletteName?.length === 0)
      newErrors.paletteName = "Palette Name is required";

    // if (selectedOptions?.styleIdentity?.length === 0)
    //   newErrors.styleIdentity = "style identity is required";

    if (selectedOptions?.flauntParts?.length === 0)
      newErrors.flauntParts = "Flaunt parts is required";
    if (selectedOptions?.downplayParts?.length === 0)
      newErrors.downplayParts = "Downplay parts is required";
    if (selectedOptions?.occasionName?.length === 0)
      newErrors.occasionName = "Occasion name is required";
    if (selectedOptions?.category?.length === 0)
      newErrors.category = "Category name is required";
    if (selectedOptions?.brand?.length === 0)
      newErrors.brand = "Brand name is required";
    if (selectedOptions?.colorName?.length === 0)
      newErrors.colorName = "color name is required";


    // if (!formData.description)
    //   newErrors.description = "Description is required";
    // else if (isNaN(Number(formData.price)) || Number(formData.price) <= 0)
    //   newErrors.price = "Price must be a positive number";
    // if (formData.heightInchValue.length === 0)
    //   newErrors.heightInchValue = "Please select height ";

    // if (formData.bodyShape.length === 0)
    //   newErrors.bodyShape = "At least one bodyShape is required";
    // if (formData.bodyShapeValue.length === 0)
    //   newErrors.bodyShapeValue = "Body shape value is required";

    // if (formData.styleIdentity.length === 0)
    //   newErrors.styleIdentity = "At least one styleIdentity is required";

    // // if (formData.styleIdentityValue.length === 0)
    // //   newErrors.styleIdentityValue = "StyleIdentity value is required";

    // if (!formData.brand) newErrors.brand = "Please select brand";
    // if (!formData.category) newErrors.category = "Please select category";
    // if (!formData.color) newErrors.colorName = "Please select color";
    // // Array validations
    // if (formData.flauntParts.length === 0)
    //   newErrors.flauntParts = "At least one flaunt part is required";
    // if (formData.flauntPartsValue.length === 0)
    //   newErrors.flauntPartsValue = "Flaunt Parts Value is required";
    // if (formData.downplayParts.length === 0)
    //   newErrors.downplayParts = "At least one downplay part is required";
    // if (formData.downplayPartsValue.length === 0)
    //   newErrors.downplayPartsValue = "Downplay parts value is required";
    // if (!showSize && availableSizes.length === 0)
    //   newErrors.availableSizes = "Available size  is required";
    // if (paletteName.length === 0)
    //   newErrors.paletteName = "Palette name is required";
    // if (occasionName.length === 0)
    //   newErrors.occasionName = "Occasion name is required";
    // // Images validation

    if (!formData.description)
      newErrors.description = "Description is required";
    if (formData.images.length === 0)
      newErrors.images = "At least one image is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {

      setButtonLoaders(true);

      let payLoad = {
        paletteName: selectedOptions.paletteName?.map((item) => item.value),
        occasion: selectedOptions.occasionName?.map((item) => item.value),
        categoryId: selectedOptions.category,
        color: selectedOptions.colorName,
        brandId: selectedOptions.brand,
        bodyShape: selectedOptions.bodyShape?.map((item) => item.value),
        styleIdentity: selectedOptions.styleIdentity?.map((item) => item.value),
        flauntParts: selectedOptions.flauntParts?.map((item) => item.value),
        downplayParts: selectedOptions.downplayParts?.map((item) => item.value),
        height: selectedOptions.height?.map((item) => item.value),
        sizes: selectedOptions.availableSizes?.map((item) => item.value),
        // scrapeUrl: debouncedValue,
        // products: selectedProducts,
      };
      const formDatas = new FormData();
      formDatas.append("title", formData.title);
      formDatas.append("price", formData.price);
      formDatas.append("quantity", formData.stockQuantity);
      formDatas.append("description", formData.description);
      formDatas.append("color", JSON.stringify(payLoad.color));
      formDatas.append("height", JSON.stringify(payLoad.height));
      formDatas.append("bodyShape", JSON.stringify(payLoad.bodyShape));
      formDatas.append("styleIdentity", JSON.stringify(payLoad.styleIdentity));
      formDatas.append("flauntParts", JSON.stringify(payLoad.flauntParts));
      formDatas.append("downplayParts", JSON.stringify(payLoad.downplayParts));
      formDatas.append("brandId", payLoad.brandId);
      formDatas.append("categoryId", payLoad.categoryId);
      formDatas.append("sizes", JSON.stringify(payLoad.sizes));
      formDatas.append("paletteName", JSON.stringify(payLoad.paletteName));
      formDatas.append("occasion", JSON.stringify(payLoad.occasion));


      // formDatas.append("color", JSON.stringify(formData.color));
      // formDatas.append("height", JSON.stringify(formData.heightInch));
      // formDatas.append("bodyShape", JSON.stringify(formData.bodyShape));
      // formDatas.append("styleIdentity", JSON.stringify(formData.styleIdentity));
      // formDatas.append("flauntParts", JSON.stringify(formData.flauntParts));
      // formDatas.append("downplayParts", JSON.stringify(formData.downplayParts));
      // formDatas.append("brandId", formData.brand);
      // formDatas.append("categoryId", formData.category);
      // formDatas.append("sizes", JSON.stringify(availableSizes));
      // formDatas.append("paletteName", JSON.stringify(paletteName));
      // formDatas.append("occasion", JSON.stringify(occasionName));


      // formDatas.append("scrapeUrl", payLoad.scrapeUrl);
      // formDatas.append("products", JSON.stringify(payLoad.products));


      formData.images.forEach((image) => {
        formDatas.append("images", image.file);
      });
      const res = await addProductApi(formDatas);
      if (res?.data?.status === 200) {
        toastMessage(res?.data?.message, "success", "addProduct");
        setButtonLoaders(false)
        navigate(-1);
      }
    } catch (e) {
      toastMessage(e.message, "error", "addProduct");
    } finally {
      setButtonLoaders(false);
    }
  };
  const handleflauntParts = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      flauntParts: selectedOptions.map((option) => option.value),
      flauntPartsValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, flauntPartsValue: null }));
  };
  const styleIdentityArray = [
    { value: "Bold Boss", label: "Bold Boss" },
    { value: "Dreamy Diva", label: "Dreamy Diva" },
    { value: "Timeless Queen", label: "Timeless Queen" },
    { value: "Effortless Chic", label: "Effortless Chic" },
  ];
  const handleStyleIdentity = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      styleIdentity: selectedOptions.map((option) => option.value),
      styleIdentityValue: selectedOptions,
    }));
    // setErrors((prevData) => ({ ...prevData, styleIdentityValue: null }));
  };
  const bodyShapeArray = [
    { value: "Round", label: "Round" },
    { value: "Triangle", label: "Triangle" },
    { value: "Hourglass", label: "Hourglass" },
    { value: "Rectangle", label: "Rectangle" },
    { value: "Inverted Triangle", label: "Inverted Triangle" },
  ];
  const handleBodyShape = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      bodyShape: selectedOptions.map((option) => option.value),
      bodyShapeValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, bodyShapeValue: null }));
  };
  const handleHeight = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      heightInch: selectedOptions.map((option) => option.value),
      heightInchValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, heightInchValue: null }));
  };
  const handledownplayParts = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      downplayParts: selectedOptions.map((option) => option.value),
      downplayPartsValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, downplayPartsValue: null }));
  };
  const downplayArray = [
    { value: "Neckline", label: "Neckline" },
    { value: "Waist", label: "Waist" },
    { value: "Legs", label: "Legs" },
    { value: "Arms", label: "Arms" },
    { value: "Back", label: "Back" },
    { value: "Buttocks", label: "Buttocks" },
  ];
  const heightArray = [
    { value: "Average", label: "Average" },
    { value: "Tall", label: "Tall" },
    { value: "Petite", label: "Petite" },
  ];
  const colorListHandler = async () => {
    try {
      const res = await masterColorApi();
      if (res?.data?.status === 200) {
        setColorList(res.data?.data?.colors);
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      toastMessage(e.message, "error", "categoryList");
    }
  };
  const categoryListHandler = async () => {
    try {
      const res = await masterClothingCategoriesListApi();

      if (res?.data?.status === 200) {
        setCategoryList(res.data?.data?.categories);
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      toastMessage(e.message, "error", "categoryList");
    }
  };
  const sizeListHandler = async (type = sizeType) => {
    try {
      const res = await masterSizeApi({ type });

      if (res?.data?.status === 200) {
        const sizeOptions = res.data?.data?.sizes.map((size) => ({
          value: size.name,
          label: size.name,
        }));
        setSizeList(sizeOptions);
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      toastMessage(e.message, "error", "categoryList");
    }
  };

  const brandListHandler = async () => {
    // try {
    //   const res = await masterBrandListApi();
    //   if (res?.data?.status === 200) {
    //     setBrandList(res.data?.data?.brands);
    //   } else {
    //     toastMessage(res?.data?.message, "error", "brand");
    //   }
    // } catch (e) {
    //   toastMessage(e.message, "error", "brand");
    // }
  };
  useEffect(() => {
    colorListHandler();
    categoryListHandler()
    brandListHandler();
    sizeListHandler()
  }, []);

  useEffect(() => {

    sizeListHandler()
  }, [sizeType]);
  return (
    <div className="addClass">
      <div className="dashboard_title has_child">
        <h3>
          <Link to={"/product-management/exclusive"}>
            <IoMdArrowRoundBack />
          </Link>{" "}
          Add Product
        </h3>
        <CustomButton type="button" className="button" ref={buttonLoaders} onClick={handleSubmit}>
          Save and Submit
        </CustomButton>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="form_field_wrap">
              <div className="form_field">
                <Input
                  type="text"
                  label="Title"
                  name="title"
                  placeholder="Enter Title"
                  value={formData.title}
                  onChange={handleInputChange}
                  error={errors.title}
                />
              </div>
              <div className="form_field">
                <Input
                  type="number"
                  label="Price"
                  name="price"
                  placeholder="Enter Price"
                  value={formData.price}
                  onChange={handleInputChange}
                  error={errors.price}
                />
              </div>
              {/* <div className="form_field">
                <label className="label">
                  Category <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className="input form-control"
                  type="text"
                  value={formData.category || ""}
                  name="category"
                  onChange={handleInputChange}
                >
                  <option value={""} >Select Category</option>
                  {categoryList?.map((data) => (
                    <option key={data._id} value={data.name}>
                      {data.name}
                    </option>
                  ))}
                </select>
                {errors && <div className="text-danger">{errors.category}</div>}
              </div> */}
            </div>
            <div className="form_field">
              <Input
                type="number"
                label="Stock Quantity"
                name="stockQuantity"
                placeholder="Enter Stock Quantity"
                value={formData.stockQuantity}
                onChange={handleInputChange}
                error={errors.stockQuantity}
              />
            </div>

            <Form {...{ selectedOptions, setSelectedOptions, errors, setErrors, sizeType, setSizeType }} />
            <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Description</label>
                <JoditEditor
                  ref={editor}
                  value={formData.description}
                  config={config}
                  tabIndex={1}
                  onBlur={(newContent) => {
                    setFormData((prevData) => ({
                      ...prevData,
                      description: newContent,
                    }));
                    setErrors((prevData) => ({
                      ...prevData,
                      description: null,
                    }));
                  }}

                />
                {errors && (
                  <div className="text-danger">{errors.description}</div>
                )}
              </div>
              <div className="form_field">
                <label className="label">Upload Images</label>
                <div className="upload_button_wrap">
                  <label htmlFor="upload_images" className="upload_button input">
                    <IoCloudUploadOutline className="icon" />
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={handleImageChange}
                      id="upload_images"
                    />
                    <span className="text">Select file to upload</span>

                  </label>
                  {errors && (
                    <div className="text-danger error-msg">{errors.images}</div>
                  )}

                  <div className="image_preview_wrap">
                    {formData.images.map((image, index) => (
                      <div className="image_preview" key={index}>
                        <img src={image.preview} alt="Preview" width="100" />
                        <button
                          type="button"
                          className="remove_image_button"
                          onClick={() => handleImageRemove(index)}
                        >
                          <GoX />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddProduct;
